<template>
<div class="chapter">
<div class="inner_page">
<p class="h1" id="pz5-1" style="text-align:left">
					Contents </p>
<p class="ctt" id="pz5-2">
<b><a href="#/Why_Rule_of_Thumb#b1" id="a1">Why Rule of Thumb?</a></b> </p>
<p class="ctt" id="pz5-3">
<b><a href="#/Introduction#b2a" id="a2a">Introduction</a></b> </p>
<p class="ctt" id="pz5-4">
<b><a href="#/chapter01#b2" id="a2">Chapter 1:</a></b> </p>
<p class="ctt1" id="pz5-5">
<a href="#/chapter01#b3" id="a3">What Is Communication, and Why Should I Care About Doing It Well? </a></p>
<p class="ctt" id="pz5-7">
<b><span href="#/chapter02#b4" id="a4" title="Link target outside of Sample">Chapter 2:</span></b> </p>
<p class="ctt1" id="pz5-8">
<span href="#/chapter02#b5" id="a5" title="Link target outside of Sample">What Are Some Typical Written Business Formats I May Need to Use? </span></p>
<p class="ctt" id="pz5-10">
<b><span href="#/chapter03#b6" id="a6" title="Link target outside of Sample">Chapter 3:</span></b> </p>
<p class="ctt1" id="pz5-11">
<span href="#/chapter03#b7" id="a7" title="Link target outside of Sample">Step-by-Step Approach to Writing, i.e., Getting Rid of Writer’s Block </span></p>
<p class="ctt" id="pz5-13">
<b><span href="#/chapter04#b8" id="a8" title="Link target outside of Sample">Chapter 4:</span></b> </p>
<p class="ctt1" id="pz5-14">
<span href="#/chapter04#b9" id="a9" title="Link target outside of Sample">What Is Nonverbal Communication, and How Do I Use It? </span></p>
<p class="ctt" id="pz5-16">
<b><span href="#/chapter05#b10" id="a10" title="Link target outside of Sample">Chapter 5:</span></b> </p>
<p class="ctt1" id="pz5-17">
<span href="#/chapter05#b11" id="a11" title="Link target outside of Sample">Oral Presentations: Do I Really Have to Talk in Front of a Group? </span></p>
<p class="ctt" id="pz6-1">
<b><span href="#/chapter06#b12" id="a12" title="Link target outside of Sample">Chapter 6:</span></b> </p>
<p class="ctt1" id="pz6-2">
<span href="#/chapter06#b13" id="a13" title="Link target outside of Sample">Cross-Cultural, Inter-Generational and Cross-Gender Communication </span></p>
<p class="ctt" id="pz6-4">
<b><span href="#/chapter07#b14" id="a14" title="Link target outside of Sample">Chapter 7:</span></b> </p>
<p class="ctt1" id="pz6-5">
<span href="#/chapter07#b15" id="a15" title="Link target outside of Sample">Networking Skills, or the Gentle Art of Schmoozing </span></p>
<p class="ctt" id="pz6-7">
<b><span href="#/chapter08#b16" id="a16" title="Link target outside of Sample">Chapter 8:</span></b> </p>
<p class="ctt1" id="pz6-8">
<span href="#/chapter08#b17" id="a17" title="Link target outside of Sample">How Can I Improve the Way I Communicate? </span></p>
<p class="ctt" id="pz6-10">
<b><span href="#/chapter09#b18" id="a18" title="Link target outside of Sample">Chapter 9:</span></b> </p>
<p class="ctt1" id="pz6-11">
<span href="#/chapter09#b19" id="a19" title="Link target outside of Sample">The “Red Flag” List </span></p>
<p class="ctt" id="pz6-12">
<b><span href="#/Afterword#b20" id="a20" title="Link target outside of Sample">AFTERWORD</span></b> </p>
<p class="ctt" id="pz6-13">
<b><span href="#/Suggested_resources#b21" id="a21" title="Link target outside of Sample">SUGGESTED RESOURCES</span></b> </p>
<p class="ctt" id="pz6-14">
<b><span href="#/References#b22" id="a22" title="Link target outside of Sample">REFERENCES</span></b> </p>
<p class="ctt" id="pz6-15">
<b><span href="#/About_the_author#b23" id="a23" title="Link target outside of Sample">ABOUT THE AUTHOR</span></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3a08e794